import TestTranslationProvider from './TestTranslationProvider'
import translate from './translate'
import { TranslationContext } from './TranslationContext'
import TranslationProvider from './TranslationProvider'
import useLocale from './useLocale'
import useSetLocale from './useSetLocale'
import useTranslate from './useTranslate'
import { useTranslateParse } from './useTranslateParse'

// Alias to translate to avoid shadowed variable names error with tslint
const withTranslate = translate

export * from './TranslationContext'
export * from './TranslationMessages'
export * from './TranslationUtils'
export {
  translate,
  withTranslate,
  TranslationContext,
  TranslationProvider,
  TestTranslationProvider,
  useLocale,
  useSetLocale,
  useTranslate,
  useTranslateParse,
}
export const DEFAULT_LOCALE = 'en'
